﻿<template>
    <div class="express-list-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <div class="search-box">
                <el-input 
                    v-model="CurSearch" 
                    placeholder="请输入姓名/考生号/证件号码/快递单号" 
                    clearable
                    @keyup.enter.native="OnSearch(2)"
                    style="width: 350px;">
                    <i slot="prefix" class="el-icon-search"></i>
                </el-input>
                <el-button type="primary" icon="el-icon-search" @click="OnSearch(2)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="OnSearch(1)">重置</el-button>
                <el-button type="success" icon="el-icon-upload" @click="showImportDialog">导入快递单号</el-button>
            </div>

            <div class="data-table">
                <el-table 
                    :data="List" 
                    border 
                    stripe
                    style="width: 100%"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                    empty-text="暂无数据"
                    ref="table"
                    height="calc(100vh - 350px)"
                    @filter-change="handleFilterChange">
                    
                    <el-table-column type="index" label="序号" width="60" align="center" fixed="left"></el-table-column>
                    
                    <!-- 招生类型 -->
                    <el-table-column prop="XZ_ZSLXMC" label="招生类型" width="120" align="center">
                        <template slot="header">
                            <span>招生类型</span>
                            <table-column-filter field="XZ_ZSLXMC" :options="getFilters('XZ_ZSLXMC')" :value="activeFilters['XZ_ZSLXMC']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <!-- 层次 -->
                    <el-table-column prop="CCMC" label="层次" width="80" align="center">
                        <template slot="header">
                            <span>层次</span>
                            <table-column-filter field="CCMC" :options="getFilters('CCMC')" :value="activeFilters['CCMC']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <!-- 省份 -->
                    <el-table-column prop="G_Sheng" label="省份" width="100" align="center">
                        <template slot="header">
                            <span>省份</span>
                            <table-column-filter field="G_Sheng" :options="getFilters('G_Sheng')" :value="activeFilters['G_Sheng']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <!-- 科类 -->
                    <el-table-column prop="XZ_KLMC" label="科类" width="100" align="center">
                        <template slot="header">
                            <span>科类</span>
                            <table-column-filter field="XZ_KLMC" :options="getFilters('XZ_KLMC')" :value="activeFilters['XZ_KLMC']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <!-- 批次 -->
                    <el-table-column prop="XZ_PCMC" label="批次" width="120" align="center">
                        <template slot="header">
                            <span>批次</span>
                            <table-column-filter field="XZ_PCMC" :options="getFilters('XZ_PCMC')" :value="activeFilters['XZ_PCMC']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <!-- 专业 -->
                    <el-table-column prop="XZ_ZYMC" label="专业" width="150" align="center" show-overflow-tooltip>
                        <template slot="header">
                            <span>专业</span>
                            <table-column-filter field="XZ_ZYMC" :options="getFilters('XZ_ZYMC')" :value="activeFilters['XZ_ZYMC']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <!-- 学院 -->
                    <el-table-column prop="G_XYMC" label="学院" width="150" align="center" show-overflow-tooltip>
                        <template slot="header">
                            <span>学院</span>
                            <table-column-filter field="G_XYMC" :options="getFilters('G_XYMC')" :value="activeFilters['G_XYMC']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="KSH" label="考生号" width="160" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="XM" label="姓名" width="100" align="center"></el-table-column>
                    
                    <!-- 性别 -->
                    <el-table-column prop="XBMC" label="性别" width="60" align="center">
                        <template slot="header">
                            <span>性别</span>
                            <table-column-filter field="XBMC" :options="getFilters('XBMC')" :value="activeFilters['XBMC']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="ZJHM" label="证件号码" width="180" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="SJR" label="收件人" width="100" align="center"></el-table-column>
                    <el-table-column prop="LXDH" label="联系电话" width="130" align="center"></el-table-column>
                    <el-table-column prop="LXSJ" label="联系手机" width="130" align="center"></el-table-column>
                    <el-table-column prop="TXDZ" label="家庭地址" width="200" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="YZBM" label="邮政编码" width="100" align="center"></el-table-column>
                    <el-table-column prop="G_EMSNO" label="快递单号" width="180" align="center" fixed="right"></el-table-column>
                    
                    <el-table-column label="操作" width="150" align="center" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
                            <el-button type="text" size="small" @click="handleViewExpress(row)" :disabled="!row.G_EMSNO">查看物流</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="PageInfo.CurPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="PageInfo.RecordCountOfPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="PageInfo.RecordCount">
                </el-pagination>
            </div>
        </div>

        <!-- 导入对话框 -->
        <el-dialog title="导入快递单号" :visible.sync="importDialogVisible" width="700px">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <div>
                    <p><strong>说明：</strong></p>
                    <ul>
                        <li>请下载Excel模板，按照模板格式填写快递单号</li>
                        <li>模板包含字段：证件号码或考生号、快递单号</li>
                        <li>系统将根据证件号码或考生号匹配考生信息并导入快递单号</li>
                    </ul>
                </div>
            </div>

            <div class="actions">
                <el-button type="success" icon="el-icon-download" @click="downloadTemplate">下载Excel模板</el-button>
            </div>

            <el-divider></el-divider>

            <el-form :model="importForm" label-width="120px">
                <el-form-item label="Excel文件">
                    <el-upload
                        class="upload-demo"
                        action="#"
                        :auto-upload="false"
                        :on-change="handleFileChange"
                        :on-remove="handleFileRemove"
                        :file-list="fileList"
                        accept=".xlsx,.xls"
                        :limit="1">
                        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件</div>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleImportSubmit" :disabled="!uploadFile || importing" :loading="importing">
                        开始导入
                    </el-button>
                </el-form-item>
            </el-form>

            <div v-if="importResult" class="result-section">
                <el-divider>导入结果</el-divider>
                <div v-html="importResult" class="result-content"></div>
            </div>
        </el-dialog>

        <!-- 编辑快递单号对话框 -->
        <el-dialog title="设置快递单号" :visible.sync="editDialogVisible" width="600px">
            <el-form :model="editForm" label-width="100px">
                <el-form-item label="考生号">
                    <span>{{ editForm.KSH }}</span>
                </el-form-item>
                <el-form-item label="姓名">
                    <span>{{ editForm.XM }}</span>
                </el-form-item>
                <el-form-item label="证件号码">
                    <span>{{ editForm.ZJHM }}</span>
                </el-form-item>
                <el-form-item label="收件人">
                    <el-input v-model="editForm.SJR" placeholder="请输入收件人" clearable></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input v-model="editForm.LXDH" placeholder="请输入联系电话" clearable></el-input>
                </el-form-item>
                <el-form-item label="联系手机">
                    <el-input v-model="editForm.LXSJ" placeholder="请输入联系手机" clearable></el-input>
                </el-form-item>
                <el-form-item label="家庭地址">
                    <el-input v-model="editForm.TXDZ" placeholder="请输入家庭地址" type="textarea" :rows="3" clearable></el-input>
                </el-form-item>
                <el-form-item label="邮政编码">
                    <el-input v-model="editForm.YZBM" placeholder="请输入邮政编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="快递单号">
                    <el-input v-model="editForm.G_EMSNO" placeholder="请输入快递单号" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveExpressNo" :loading="saving">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 输入手机号弹窗 -->
        <el-dialog title="输入手机号后4位" :visible.sync="telDialogVisible" width="500px">
            <div class="tel-input-section">
                <p class="tel-hint">查询顺丰快递需要输入收件人手机号后4位</p>
                <el-input 
                    v-model="telInput" 
                    placeholder="请输入4位数字" 
                    maxlength="4" 
                    @keyup.enter.native="confirmTelInput"
                    @keydown.enter.native="confirmTelInput"
                    class="tel-input">
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeTelDialog">取 消</el-button>
                <el-button type="primary" @click="confirmTelInput">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 查看物流对话框 -->
        <el-dialog title="物流信息" :visible.sync="expressDialogVisible" width="800px">
            <div v-loading="loadingExpress">
                <div v-if="expressInfo">
                    <div class="express-header">
                        <div class="express-item">
                            <span class="label">快递单号：</span>
                            <span class="value">{{ expressInfo.EmsNo }}</span>
                        </div>
                        <div class="express-item">
                            <span class="label">当前状态：</span>
                            <el-tag :type="getExpressStatusType(expressInfo.Status)">
                                {{ getStatusText(expressInfo.Status) }}
                            </el-tag>
                        </div>
                    </div>

                    <el-divider></el-divider>

                    <div class="express-timeline">
                        <el-timeline>
                            <el-timeline-item 
                                v-for="(item, index) in expressInfo.TraceList" 
                                :key="index"
                                :timestamp="formatTime(item.Time)"
                                :type="index === 0 ? 'primary' : ''">
                                <p>{{ item.Text }}</p>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </div>
                <div v-else-if="!loadingExpress">
                    <el-empty description="暂无物流信息"></el-empty>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';
    import TableColumnFilter from '../Shared/TableColumnFilter.vue';

    export default {
        name: 'ExpressList',
        components: {
            TableColumnFilter
        },
        inject: ['Loading', 'LoadingCompleted'],
        computed: {
            noPhotoCount() {
                if (!this.rawList) return 0;
                return this.rawList.filter(row => !row.G_ZP || row.G_ZP.trim() === '').length;
            }
        },
        data: function () {
            return {
                Status: {
                    LoadingCompleted: false
                },
                PageInfo: {
                    CurPage: 1,
                    PageCount: 1,
                    RecordCount: 1,
                    RecordCountOfPage: 20
                },
                CurSearch: '',
                photoFilter: '',
                List: [],
                rawList: [],
                activeFilters: {},
                allFilters: {},
                
                // 导入对话框
                importDialogVisible: false,
                importForm: {},
                fileList: [],
                uploadFile: null,
                importing: false,
                importResult: '',
                
                // 编辑对话框
                editDialogVisible: false,
                editForm: {},
                saving: false,
                
                // 物流对话框
                expressDialogVisible: false,
                expressInfo: null,
                loadingExpress: false,
                telDialogVisible: false,
                telInput: '',
                currentExpressNo: ''
            }
        },
        methods: {
            getFilters(prop) {
                if (prop === 'G_ZP') {
                    return [
                        { text: '是', value: 'hasPhoto' },
                        { text: '否', value: 'noPhoto' }
                    ];
                }
                if (this.allFilters[prop]) {
                    return this.allFilters[prop].map(f => ({ text: f.Label, value: f.Value }));
                }
                if (!this.rawList || this.rawList.length === 0) return [];
                const values = new Set();
                this.rawList.forEach(row => {
                    const val = row[prop];
                    if (val !== null && val !== undefined && val !== '') {
                        values.add(val);
                    }
                });
                return Array.from(values).sort().map(val => ({ text: val, value: val }));
            },
            handleCustomFilter({ field, values }) {
                if (values && values.length > 0) {
                    this.$set(this.activeFilters, field, values);
                } else {
                    this.$delete(this.activeFilters, field);
                }
                this.applyFilters();
            },
            applyFilters() {
                let result = this.rawList;
                
                Object.keys(this.activeFilters).forEach(key => {
                    const values = this.activeFilters[key];
                    if (values && values.length > 0) {
                        if (key === 'G_ZP') {
                            if (values.includes('hasPhoto')) {
                                result = result.filter(row => row.G_ZP && row.G_ZP.trim() !== '');
                            }
                            if (values.includes('noPhoto')) {
                                result = result.filter(row => !row.G_ZP || row.G_ZP.trim() === '');
                            }
                        } else {
                            result = result.filter(row => values.includes(row[key]));
                        }
                    }
                });
                
                this.List = result;
                
                this.$nextTick(() => {
                    if (this.$refs.table) {
                        this.$refs.table.doLayout();
                    }
                });
            },
            handleFilterChange() {
                this.$nextTick(() => {
                    if (this.$refs.table) {
                        this.$refs.table.doLayout();
                    }
                });
            },
            OnSearch: function (type) {
                var that = this;
                if (type == 1) {
                    that.CurSearch = '';
                    that.photoFilter = '';
                    ['XZ_ZSLXMC', 'CCMC', 'G_Sheng', 'XZ_KLMC', 'XZ_PCMC', 'XZ_ZYMC', 'G_XYMC', 'XBMC'].forEach(field => {
                        that.$set(that.activeFilters, field, []);
                    });
                    that.LoadList();
                } else if (type == 2) {
                    that.LoadList();
                } else {
                    that.CurSearch = '';
                    that.photoFilter = '';
                    ['XZ_ZSLXMC', 'CCMC', 'G_Sheng', 'XZ_KLMC', 'XZ_PCMC', 'XZ_ZYMC', 'G_XYMC', 'XBMC'].forEach(field => {
                        that.$set(that.activeFilters, field, []);
                    });
                    that.LoadList();
                }
            },
            ToPage: function (pageIdx, pageCount) {
                var that = this;
                that.LoadList(pageIdx, pageCount);
            },
            handleSizeChange(val) {
                this.ToPage(1, val);
            },
            handleCurrentChange(val) {
                this.ToPage(val, this.PageInfo.RecordCountOfPage);
            },
            LoadList: function (pageIdx, pageCount) {
                var that = this;

                var api_name = '/Notice/GetExpressList';
                var url = TYBM_Env.GetApiUrl(api_name) + '?Search=' + encodeURIComponent(that.CurSearch || '');
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Tools.AppendPageInfo(url, pageIdx, pageCount), { loading_msg: '正在加载数据' })
                    .then(result => {
                        that.PageInfo = result.data.PageInfo;
                        that.rawList = result.data.List;
                        that.allFilters = result.data.AllFilters || {};
                        that.applyFilters();
                        that.Status.LoadingCompleted = true;
                    }).catch(() => { });
            },
            showImportDialog() {
                this.importDialogVisible = true;
                this.fileList = [];
                this.uploadFile = null;
                this.importResult = '';
            },
            downloadTemplate() {
                window.open('/GXZS/Template/v1快递单号导入模板.xls', '_blank');
            },
            handleFileChange(file) {
                this.uploadFile = file.raw;
            },
            handleFileRemove() {
                this.uploadFile = null;
            },
            handleImportSubmit() {
                var that = this;
                var api_name = "/Notice/ImportEmpNo";
                var data = { "RarFile": that.uploadFile };
                var year = this.$root.currentYear || '';
                var url = TYBM_Env.GetApiUrl(api_name) + (year ? '?year=' + year : '');
                
                that.importing = true;
                TYBM_Tools.AxiosUploadFile(that, api_name, url, data, { loading_msg: '正在处理', has_progress: true })
                    .then(result => {
                        that.importResult = result.data.Msg;
                        that.$message.success('导入完成');
                        that.LoadList(); // 重新加载列表
                    })
                    .catch(() => {
                        that.$message.error('导入失败');
                    })
                    .finally(() => {
                        that.importing = false;
                    });
            },
            handleEdit(row) {
                this.editForm = {
                    G_SN: row.G_SN,
                    KSH: row.KSH,
                    XM: row.XM,
                    ZJHM: row.ZJHM,
                    SJR: row.SJR || '',
                    LXDH: row.LXDH || '',
                    LXSJ: row.LXSJ || '',
                    TXDZ: row.TXDZ || '',
                    YZBM: row.YZBM || '',
                    G_EMSNO: row.G_EMSNO || ''
                };
                this.editDialogVisible = true;
            },
            handleSaveExpressNo() {
                var that = this;
                var api_name = '/Notice/SetExpressNo';
                var url = TYBM_Env.GetApiUrl(api_name);
                var data = {
                    Model: JSON.stringify({
                        G_SN: that.editForm.G_SN,
                        G_EMSNO: that.editForm.G_EMSNO,
                        TXDZ: that.editForm.TXDZ,
                        YZBM: that.editForm.YZBM,
                        LXSJ: that.editForm.LXSJ,
                        LXDH: that.editForm.LXDH,
                        SJR: that.editForm.SJR
                    })
                };
                
                that.saving = true;
                TYBM_Tools.AxiosPostEx(that, api_name, url, data, { loading: false })
                    .then(() => {
                        that.$message.success('设置成功');
                        that.editDialogVisible = false;
                        that.LoadList();
                    })
                    .finally(() => {
                        that.saving = false;
                    });
            },
            handleViewExpress(row) {
                if (!row.G_EMSNO) {
                    this.$message.warning('该考生未设置快递单号');
                    return;
                }
                
                this.currentExpressNo = row.G_EMSNO;
                this.telInput = '';
                this.telDialogVisible = true;
            },
            confirmTelInput() {
                var tel = this.telInput.trim();
                if (!/^\d{4}$/.test(tel)) {
                    this.$message.warning('请输入4位数字');
                    return;
                }
                
                this.telDialogVisible = false;
                this.expressInfo = null;
                this.expressDialogVisible = true;
                this.loadingExpress = true;
                
                var api_name = '/Public/GetExpressInfoByEms';
                var url = TYBM_Env.GetApiUrl(api_name) + '?emsNo=' + encodeURIComponent(this.currentExpressNo) + '&tel=' + encodeURIComponent(tel);
                
                TYBM_Tools.AxiosGetEx(this, api_name, url, { loading: false })
                    .then(result => {
                        this.expressInfo = result.data;
                    })
                    .catch(() => {
                        this.$message.error('查询物流信息失败');
                    })
                    .finally(() => {
                        this.loadingExpress = false;
                    });
            },
            closeTelDialog() {
                this.telDialogVisible = false;
                this.telInput = '';
            },
            getExpressStatusType(status) {
                const statusMap = {
                    'SIGN': 'success',
                    'TRANSPORT': 'primary',
                    'ACCEPT': 'info',
                    'FAILED': 'danger'
                };
                return statusMap[status] || 'info';
            },
            getStatusText(status) {
                const statusMap = {
                    'SIGN': '已签收',
                    'TRANSPORT': '运输中',
                    'ACCEPT': '已揽收',
                    'FAILED': '投递失败'
                };
                return statusMap[status] || '未知';
            },
            formatTime(timeStr) {
                if (!timeStr) return '';
                return timeStr;
            }
        },
        created: function () {
            var that = this;
            that.PageInfo.CurPage = that.$route.query.Page || 1;
            that.LoadList();
        }
    }
</script>

<style scoped>
.express-list-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    align-items: center;
}

.data-table {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
}

.data-table >>> .el-table {
    font-size: 13px;
}

.data-table >>> .el-table th,
.data-table >>> .el-table td {
    padding: 0 !important;
    height: 40px !important;
}

.data-table >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table >>> .el-table__row {
    height: 40px !important;
}

.data-table >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table >>> .el-table .cell {
    padding: 0 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 40px !important;
}

.data-table >>> .el-table th > .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    line-height: normal !important;
}

.data-table >>> .el-button--text {
    color: #409EFF;
    padding: 0;
}

.data-table >>> .el-button--text:hover {
    color: #66b1ff;
}

.data-table >>> .el-button--text:disabled {
    color: #c0c4cc;
}

.no-photo-count {
    margin-top: 15px;
    padding: 10px 20px;
    background-color: #fef0f0;
    border: 1px solid #fbc4c4;
    border-radius: 4px;
    text-align: center;
}

.no-photo-count span {
    color: #d93026;
    font-weight: bold;
    font-size: 14px;
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

/* 导入对话框样式 */
.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid #1890ff;
    background-color: #e6f7ff;
    color: #0050b3;
    display: flex;
    gap: 12px;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
}

.actions {
    margin-bottom: 20px;
}

.result-section {
    margin-top: 20px;
}

.result-content {
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    max-height: 300px;
    overflow-y: auto;
}

.upload-demo >>> .el-upload {
    display: inline-block;
}

.upload-demo >>> .el-upload input[type="file"] {
    display: none !important;
}

/* 物流对话框样式 */
.express-header {
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.express-item {
    margin-bottom: 10px;
    font-size: 14px;
}

.express-item:last-child {
    margin-bottom: 0;
}

.express-item .label {
    font-weight: 600;
    color: #606266;
}

.express-item .value {
    color: #303133;
}

.express-timeline {
    margin-top: 20px;
    max-height: 500px;
    overflow-y: auto;
}
</style>
